export const EASY_NOTIFICATIONS_IDENTIFIER = "easy-notifications";

export const MAX_NOTIFICATIONS = 5;

export const DEFAULT_NOTIFICATION_DURATION = 5000;

export const PROGRESS_BAR_CHUNKS = 100;
